import axios from "axios";
import { BACKEND_URL } from "./apiConfig";
import { log } from "../utils/logger";
import { getAuthToken, getAuthHeader, getPublicHeader } from "./authUtils";

/**
* Fetches storage items from the backend.
* Requires a valid authentication token stored in cookies.
*
* @throws Will throw an error if no authentication token is found.
* @throws Will throw an error if the HTTP request fails, including status code and status text.
*
* @returns {Promise<any>} Promise resolving to the storage items data from the server.
*/

type GetStorageItemsOpts = {
    subscriberId?: number | string;
    isPublicView?: boolean;
    uuid?: string;
};

export async function getStorageItems(
    opts: GetStorageItemsOpts
): Promise<any> {
    const { isPublicView, uuid } = opts;

    if(!isPublicView){
        // Normal fetch
        const token = getAuthToken();
        if (typeof uuid !== "string" || uuid.trim() === "" || uuid === "false") {
            throw new Error("UUID must be a non-empty string.");
        }

        try {
            const response = await axios.get(`${BACKEND_URL}/eshop/items/storage?uuid=${uuid}`, {
                headers: getAuthHeader(token),
            });
            log("[Fetch] storage:", response.data);
            return response.data;
        } catch (error: any) {
            throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
        }
    }else{
        // Fetch in public catalog
        try {
            const response = await axios.get(`${BACKEND_URL}/eshop/items/storage?uuid=${uuid}`, {
                headers: getPublicHeader(),
            });
            log("[Fetch] storage (public):", response.data);
            return response.data;
        } catch (error: any) {
            throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
        }
    }

}
